import Api from "./base/api-base";

export default class BudgetLatestApi {
    info (id) {
        return Api.get({
          endpoint: Api.endpoint.budget_latest,
          id: id
        });
      }
}